import qs from "query-string";
import { pickBy } from "lodash";
import { PATHS } from "config/paths";

export const sanitizeParams = (params) => pickBy(params, Boolean);

export const encodeQueryStringValue = (params) => {
	const sanitizedParams = sanitizeParams(params);

	// If params contains bookingEmail, replace spaces with +
	if (sanitizedParams.bookingEmail) {
		sanitizedParams.bookingEmail = sanitizedParams.bookingEmail.replace(
			/\s+/g,
			"+"
		);
	}

	return qs.stringify(sanitizedParams, {
		arrayFormat: "none"
	});
};

// trim trailing slash, otherwise last query param comes with a / baked in
// strip [] from legacy bracket-format keys so old bookmarked/indexed URLs still decode correctly
export const decodeQueryStringValue = (search) =>
	qs.parse(search.replace(/\/$/, "").replace(/\[\]/g, ""), {
		arrayFormat: "none"
	});

const buildUrl = (path, params) => {
	// remove trailing slash if it exists
	let url = `${path.replace(/\/$/, "")}`;
	if (params) {
		const encodedParams = encodeQueryStringValue(params);
		url = `${url}/?${encodedParams}`;
	}
	return url;
};

export default function buildSearchLink(params) {
	return buildUrl(PATHS.SEARCH, params);
}

export function buildSearchFilterLink(pathname, params) {
	return buildUrl(pathname, params);
}
